import StoredLayout from '../../layouts/StoredLayout'
import AreaChartWidgets from './AreaChartWidgets'
export default StoredLayout(AreaChartWidgets)
